import { Component } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-add-additional-service',
    templateUrl: './add-additional-service.component.html',
    styleUrl: './add-additional-service.component.scss'
})
export class AddAdditionalServiceComponent extends DialogContentBase {
    model: any = { dateFrom: new Date() };
    title: string = '';

    extensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'xsd',
        'msg',
        'txt',
        'csv',
        'rtf',
        'odt',
        'ods',
        'odp',
        'xml',
        'json',
        'jpg',
        'peg',
        'png',
        'gif',
        'bmp',
        'webp',
        'svg',
        'tiff',
        'tif',
        'zip',
        'rar',
        '7z',
        'tar',
        'gz',
        'tgz'
    ];

    constructor(public override dialog: DialogRef) {
        super(dialog);
    }

    close() {
        this.dialog.close(null);
    }

    confirm() {
        this.dialog.close(this.model);
    }

    canConfirm() {
        return this.model.statusId && this.model.typeId;
    }
}
